import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** Remonte en haut de page à chaque nouvelle route (pas sur retour/avant navigateur ni sur les ancres #). */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === 'POP' || hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, navType, hash]);

  return null;
}
